<h1 mat-dialog-title style="text-align: center;">User Status Confirmation</h1>
<div mat-dialog-content style="text-align: center;">
  <p>Are you sure you wish to change this users status?</p>
</div>
<div mat-dialog-actions style="justify-content: center;">
  <button mat-button [mat-dialog-close]="'cancel'">Cancel</button>
  <button mat-button [mat-dialog-close]="'update'" cdkFocusInitial style="margin-left: 0px;">Update</button>
</div>
